import { CARD_TYPE, COMPONENT_TYPE, COMPONENT_TYPE as TYPE } from 'common/constants';
import type { CardData, ComponentTypes } from 'types/story';
import { IS_PROD } from 'utils/environment';

const DRAFT_ITEMS_LIST: ComponentTypes[] = IS_PROD ? [] : [];

export const DEFAULT_BLOCK_ITEMS_LIST: ComponentTypes[] = [
	TYPE.BOX,
	TYPE.TEXT,
	TYPE.BUTTON,
	TYPE.IMG,
	TYPE.VIDEO,
	TYPE.LOTTIE,
	TYPE.TIMER,
	TYPE.SHAPE,
	TYPE.EMBED,
	TYPE.AD_UNIT,
	TYPE.SHARE,
	TYPE.OVERLAY,
	TYPE.COUNTER,
	TYPE.SLIDER,
	TYPE.SLIDER_ARROW,
	TYPE.SLIDER_SLIDES,
	TYPE.SLIDER_PAGINATION,
	TYPE.VISUAL_COMPARE,
	...DRAFT_ITEMS_LIST,
];

export const ADD_BLOCK_LIST: Record<CardData['type'], ComponentTypes[]> = {
	[CARD_TYPE.SANDBOX]: Object.values(TYPE).filter(
		type => !type.match(`${TYPE.CARD}|${TYPE.CONTENT}|${TYPE.FLOAT_BELOW}|${TYPE.FLOAT_ABOVE}`)
	),
	[CARD_TYPE.INFO]: [...DEFAULT_BLOCK_ITEMS_LIST, TYPE.SEARCH_FIELD, TYPE.CMS_REPEATER],
	[CARD_TYPE.REGISTRATION]: [...DEFAULT_BLOCK_ITEMS_LIST, TYPE.GOOGLE_LOGIN, TYPE.SMS_LOGIN],
	[CARD_TYPE.TRIVIA]: [...DEFAULT_BLOCK_ITEMS_LIST, TYPE.ANSWER, TYPE.ANSWER_INPUT, TYPE.BUTTON_SUBMIT],
	[CARD_TYPE.SORTABLE_TRIVIA]: [...DEFAULT_BLOCK_ITEMS_LIST, TYPE.SORTABLE_BOX, TYPE.ANSWER, TYPE.ANSWER_PROGRESS],
	[CARD_TYPE.SORTABLE_POLL]: [...DEFAULT_BLOCK_ITEMS_LIST, TYPE.SORTABLE_BOX, TYPE.ANSWER, TYPE.BUTTON_SUBMIT],
	[CARD_TYPE.POLL]: [
		...DEFAULT_BLOCK_ITEMS_LIST,
		TYPE.ANSWER,
		TYPE.ANSWER_INPUT,
		TYPE.BUTTON_SUBMIT,
		TYPE.ANSWER_PROGRESS,
	],
	[CARD_TYPE.FORM]: [
		...DEFAULT_BLOCK_ITEMS_LIST,
		TYPE.BUTTON_SUBMIT,
		TYPE.TEXT_FIELD,
		TYPE.TEXT_AREA_FIELD,
		TYPE.CHECKBOX,
		TYPE.SELECT,
		TYPE.FILE_UPLOAD_FIELD,
	],
	[CARD_TYPE.PERSONALITY_TEST]: [...DEFAULT_BLOCK_ITEMS_LIST, TYPE.ANSWER],
	[CARD_TYPE.THIS_OR_THAT]: [...DEFAULT_BLOCK_ITEMS_LIST, TYPE.ANSWER, TYPE.SWIPE],
	[CARD_TYPE.TRUE_OR_FALSE]: [...DEFAULT_BLOCK_ITEMS_LIST, TYPE.ANSWER, TYPE.SWIPE],
	[CARD_TYPE.NAVIGATION]: [...DEFAULT_BLOCK_ITEMS_LIST],
};

export const getPrettyComponentType = (name: ComponentTypes) => {
	const nameAlias = {
		[COMPONENT_TYPE.TEXT_FIELD]: 'Text field',
		[COMPONENT_TYPE.TEXT_AREA_FIELD]: 'Text area',
		[COMPONENT_TYPE.IMG]: 'Image',
		[COMPONENT_TYPE.GOOGLE_LOGIN]: 'Google login',
		[COMPONENT_TYPE.BUTTON_SUBMIT]: 'Submit',
		[COMPONENT_TYPE.SMS_LOGIN]: 'SMS login',
		[COMPONENT_TYPE.ANSWER_PROGRESS]: 'Answer progress',
		[COMPONENT_TYPE.SORTABLE_BOX]: 'Sortable box',
		[COMPONENT_TYPE.SLIDER_ARROW]: 'Arrow',
		[COMPONENT_TYPE.VIDEO]: 'Media',
		[COMPONENT_TYPE.SLIDER_PAGINATION]: 'Pagination',
		[COMPONENT_TYPE.VISUAL_COMPARE]: 'Photo Compare',
		[COMPONENT_TYPE.AD_UNIT]: 'Ad Slot',
		[COMPONENT_TYPE.SEARCH_FIELD]: 'CMS Search Field',
		[COMPONENT_TYPE.CMS_REPEATER]: 'CMS Repeater',
		[COMPONENT_TYPE.ANSWER_INPUT]: 'Answer Input',
		[COMPONENT_TYPE.FILE_UPLOAD_FIELD]: 'File Upload',
	};

	return nameAlias[name] || `${name.charAt(0).toUpperCase()}${name.toLowerCase().slice(1)}`;
};
